import React from "react"
import { formatAsPrice, formatDateTime } from "../../../../utils/formatters"
import TwoRowsCell from "../../../common/cells/TwoRowsCell"
import TwoRowsHeaderCell from "../../../common/cells/TwoRowsHeaderCell"
import type { FiltersIdentifier } from "../../../filters/types"
import ReportDataTable from "../../../common/ReportDataTable"
import type { VoidsLogReportItem } from "../../../../graphql/types"
import { Color } from "../../../../constants"

type Props = {
    data: VoidsLogReportItem[]
    reportIdentifier: FiltersIdentifier
}

class VoidsLogReportTable extends React.PureComponent<Props> {
    render() {
        const columns = [
            {
                title: "Time",
                dataIndex: "originTimestamp",
                width: "20%",
                key: "timestamp",
                render: (text, record: VoidsLogReportItem) => {
                    if (record.id === "total") {
                        return (
                            <span>
                                <b>Total</b>
                            </span>
                        )
                    }

                    return (
                        <TwoRowsCell
                            value={formatDateTime(record.originTimestamp, "h:mm A")}
                            subValue={formatDateTime(record.originTimestamp, "M/D/YYYY")}
                        />
                    )
                },
                defaultSortOrder: "descend",
                sorter: (a: VoidsLogReportItem, b: VoidsLogReportItem) =>
                    // @ts-expect-error
                    new Date(a.originTimestamp) - new Date(b.originTimestamp),
            },
            {
                title: <TwoRowsHeaderCell value="ID #" subValue="Service" />,
                key: "orderNumber",
                width: "20%",
                render: (text, record: VoidsLogReportItem) => {
                    if (record.id === "total") {
                        return null
                    }

                    return <TwoRowsCell value={record.entityNumber} subValue={record.terminalName} />
                },
            },
            {
                title: <TwoRowsHeaderCell value="Assignee" subValue="Admin" />,
                key: "assigneeName",
                width: "20%",
                render: (text, record: VoidsLogReportItem) => {
                    if (record.id === "total") {
                        return null
                    }

                    return <TwoRowsCell value={record.assigneeName} subValue={record.approvalName} />
                },
            },
            {
                title: <TwoRowsHeaderCell value="Voids Content" subValue="Reason" />,
                key: "pricingName",
                width: "20%",
                render: (text, record: VoidsLogReportItem) => {
                    if (record.id === "total") {
                        return null
                    }

                    return <TwoRowsCell value={record.content} subValue={record.reasonCode} />
                },
            },
            {
                title: "Total",
                dataIndex: "result",
                width: "20%",
                align: "right",
                render: (text, record: VoidsLogReportItem) => {
                    const value = formatAsPrice(record.amount)

                    if (record.id === "total") {
                        return record.amount >= 0 ? (
                            <span>
                                <b>{value}</b>
                            </span>
                        ) : (
                            <span
                                style={{
                                    color: Color.Red,
                                }}>
                                <b>{value}</b>
                            </span>
                        )
                    }

                    return record.amount >= 0 ? (
                        value
                    ) : (
                        <span
                            style={{
                                color: Color.Red,
                            }}>
                            {value}
                        </span>
                    )
                },
            },
        ]
        return (
            <ReportDataTable
                reportIdentifier={this.props.reportIdentifier}
                columns={columns}
                dataSource={this.props.data}
                rowKey="id"
                pagination={false}
            />
        )
    }
}

export default VoidsLogReportTable
